<template>
	<div>

		<div
		class="alert bg-primary text-white p-4 rounded text-center my-4"
		v-if="!template && canSaveTemplate">

			<p class="text-center">
				<strong class="text-white">
					{{$t('account/bookings.This mission pattern is recurring')}}
				</strong> 
				<br>
				{{$t('account/bookings.Save it and save time on your next booking')}}
				
			</p>

			<loading-button 
			:loading="loading"
			@click="openModal"
			theme="white rounded-pill">
				{{$t('account/bookings.Save template')}}
			</loading-button>


		</div>

		<div class="card card-services bg-lighten shadow-none">

			<div 
			v-if="template"
			class="card-header py-3">
				<div class="d-flex align-items-center justify-content-between small">

					<span class="template-title">
						{{$t('account/bookings.Template used')}} : 
						<b class="pl-2">
							{{booking.template.name}}
						</b>
					</span>

					<loading-button 
					v-if="canSaveTemplate"
					@click="openModal"
					theme="outline-primary btn-template btn-sm">
						{{$t('account/bookings.Update template')}}
					</loading-button>

				</div>

			</div> <!-- /.card-header -->

			<resume-services />

		</div>

		<modal 
		:title="$t('account/bookings.Template save')"
		size="lg"
		:disabled="!name"
		@submit="saveTemplate"
		:loading="loading"
		:button="$t('app.Save')"
		ref="modal">

			<input-text
			:label="$t('account/bookings.Template name')"
			v-model="name" />

		</modal>

	</div>
</template>

<script>

	import {mapState, mapGetters} from 'vuex'
	import ResumeServices from '@components/booking/resume/Services'

	export default {

		data() {
			return {
				loading: false,
				name: null
			}
		},

		components: {
			ResumeServices
		},

		computed: {

			...mapState({
				booking: state => state.booking,
				template: state => state.booking.template
			}),


			...mapGetters('booking', [
				'templateData'
			]),

			canSaveTemplate() {
				return this.booking.site 
				&& this.booking.type 
				&& this.booking.customs_type
				&& this.booking.site 
				&& this.booking.service
			}

		},

		methods: {

			openModal() {

				if(this.template)
				{
					this.name = this.template.name
				}

				this.$refs.modal.open()
			},

			saveTemplate() {
				this.loading = true

				axios
				.post('/account/bookings/template', {
					id: _.get(this.template, 'id', null),
					name: this.name,
					data: this.templateData
				})
				.then(response => {
					this.loading = false
					this.$store.commit('booking/setTemplates', response.data.templates)
					this.$store.commit('booking/setTemplate', response.data.template)
					this.$refs.modal.close()
				})
				.catch(error => {
					this.loading = false
					this.$flash(this.$t('app.An error has occured'))
				})
			}


		}

	}
</script>